import { css } from '@emotion/core';

export const globalStyles = css`
  body {
    display: block;
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: normal;
    margin: 0;
  }
`;
